'use strict';

module.exports = {
  __depends__: [ require(162) ],
  __init__: [ 'toolManager' ],
  toolManager: [ 'type', require(241) ]
};
